import React, { useState } from "react";
import moment from "moment/moment";
import SearchInput from "./SearchInput";
import CustomSelect from "./CustomSelect";
import ArrowDownIcon from "../../assets/icons/arrowDown";
import PrevIcon from "../../assets/icons/prev";
import NextIcon from "../../assets/icons/next";
import { Link } from "react-router-dom";
import { hasPermission, isAdmin } from "../../Utils/auth";
import { FiEdit } from "react-icons/fi";
import { IoMdEye } from "react-icons/io";
import EnableDisableRadio from "./EnableDisableRadio";
import Popup from "./Popup";

const EmployeeTable = ({ data, designationOptions, handleDisableEnable }) => {
  const [search, setSearch] = useState("");
  // const [designationFilter, setDesignationFilter] = useState("");
  const [locationFilter, setLocationFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [pageInput, setPageInput] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedUserStatus, setSelectedUserStatus] = useState("");
  const [disableOpen, setDisableOpen] = useState(false);

  // Filter logic
  const filteredData = data.filter((row) => {
    return (
      row.employee_name.toLowerCase().includes(search.toLowerCase()) &&
      (locationFilter ? row?.location === locationFilter : true) &&
      (statusFilter === "Active"
        ? row.user_status === 1
        : statusFilter === "Not Active"
        ? row.user_status === 0
        : true)
    );
  });

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handlePageJump = (e) => {
    e.preventDefault();
    const pageNum = parseInt(pageInput, 10);
    if (!isNaN(pageNum)) {
      handlePageChange(pageNum);
      setPageInput("");
    }
  };

  const currentRows = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Active",
      value: "Active",
    },
    {
      label: "Not Active",
      value: "Not Active",
    },
  ];

  const locationOptions = [
    {
      label: "All Location",
      value: "",
    },
    {
      label: "Dubai",
      value: "Dubai",
    },
    {
      label: "India",
      value: "India",
    },
  ];

  const handleDisable = (emp, userStatus) => {
    setSelectedEmployee(emp);
    setSelectedUserStatus(userStatus === 1 ? "Disable" : "Enable");
    setDisableOpen(true);
  };

  return (
    <div className="w-full rounded-lg">
      {/* Filters */}
      <div className="flex justify-between items-start md:flex-row gap-3 mb-4">
        <SearchInput
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by name..."
          fontSize="sm"
        />
        <div className="flex flex-grow-0 flex-shrink-0 gap-4">
          <CustomSelect
            options={locationOptions}
            placeholder="Location"
            value={locationFilter}
            onChange={(loc) => setLocationFilter(loc.value)}
            width="w-[200px]"
            height="h-[36px]"
            fontSize="sm"
            optionFontSize="sm"
          />

          <CustomSelect
            options={statusOptions}
            placeholder="Status"
            value={statusFilter}
            onChange={(des) => setStatusFilter(des.value)}
            width="w-[120px]"
            height="h-[36px]"
            fontSize="sm"
            optionFontSize="sm"
          />
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-[800px] table-auto w-full text-sm">
          <thead className="sticky top-0 bg-white z-0">
            <tr className="h-[52px] border border-l-0 border-r-0 border-[#a48572]/10 text-[#142b70]">
              <th className="px-4 text-left font-semibold whitespace-nowrap">
                Employee Name
              </th>
              <th className="px-4 text-left font-semibold whitespace-nowrap">
                Designation
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Team Leader
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Joining Date
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Phone Number
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Location
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Status
              </th>
              <th className="px-4 text-center font-semibold whitespace-nowrap">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {currentRows.length > 0 ? (
              currentRows.map((row, idx) => (
                <tr key={idx} className="relative hover:bg-[#f9f9f9]">
                  <td className="relative text-left py-3 pl-3 min-w-48">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 overflow-hidden rounded-lg bg-[#de2b26] flex items-center justify-center">
                        <span className="text-sm text-white">
                          {row.employee_name
                            ? row.employee_name.charAt(0)
                            : "N"}
                        </span>
                      </div>
                      <p className="text-sm text-[#142b70]/80">
                        {row.employee_name ? row.employee_name : "N/A"}
                      </p>
                    </div>
                  </td>

                  <td className="text-sm text-[#142b70]/80 text-left px-4 py-3">
                    {row.designation ? row.designation.title : "N/A"}
                  </td>
                  <td className="text-sm text-[#142b70]/80 text-center py-3">
                    {row.team_leader ? row.team_leader : "N/A"}
                  </td>
                  <td className="text-sm text-[#142b70]/80 text-center py-3">
                    {row.joining_date
                      ? moment(row.joining_date).format("DD MMM YYYY")
                      : "N/A"}
                  </td>
                  <td className="text-sm text-[#142b70]/80 text-center py-3">
                    {row.phone_num ? row.phone_num : "N/A"}
                  </td>
                  <td className="text-sm text-[#142b70]/80 text-center py-3">
                    {row.location ? row.location : "N/A"}
                  </td>
                  <td className="text-center py-3">
                    <div
                      className={`flex justify-center mx-auto items-center w-[90px] px-2 py-1 rounded ${
                        row.user_status === 0
                          ? "bg-[#de2b26]/10"
                          : "bg-[#32936f]/[0.16]"
                      }`}
                    >
                      <p
                        className={`text-xs ${
                          row.user_status === 0
                            ? "text-[#142b70]"
                            : "text-[#519c66]"
                        }`}
                      >
                        {row.user_status === 1 ? "Active" : "Not Active"}
                      </p>
                    </div>
                  </td>
                  <td className="text-right py-3 px-3">
                    {isAdmin() ||
                    (hasPermission("edit_employees") &&
                      hasPermission("view_employees") &&
                      hasPermission("disable_employees")) ? (
                      <div className="flex justify-center gap-2">
                        <Link
                          to={`/view-employee/${row.id}`}
                          className={`flex justify-center items-center mx-auto px-2 py-1 rounded bg-[#de2b26]/10 cursor-pointer`}
                        >
                          <IoMdEye className={`text-xs text-[#142b70]`} />
                        </Link>
                        <Link
                          to={`/employee/${row.id}`}
                          className={`flex justify-center items-center mx-auto px-2 py-1 rounded bg-[#de2b26]/10 cursor-pointer`}
                        >
                          <FiEdit className={`text-xs text-[#142b70]`} />
                        </Link>
                        <EnableDisableRadio
                          enabled={row.user_status === 1 ? true : false}
                          handleStatusToggle={() =>
                            handleDisable(row, row.user_status)
                          }
                        />
                      </div>
                    ) : hasPermission("edit_employees") &&
                      hasPermission("view_employees") ? (
                      <div className="flex justify-center gap-2">
                        <Link
                          to={`/view-employee/${row.id}`}
                          className={`flex justify-center items-center mx-auto px-2 py-1 rounded bg-[#de2b26]/10 cursor-pointer`}
                        >
                          <IoMdEye className={`text-xs text-[#142b70]`} />
                        </Link>
                        <Link
                          to={`/employee/${row.id}`}
                          className={`flex justify-center items-center mx-auto px-2 py-1 rounded bg-[#de2b26]/10 cursor-pointer`}
                        >
                          <FiEdit className={`text-xs text-[#142b70]`} />
                        </Link>
                      </div>
                    ) : hasPermission("edit_employees") ? (
                      <div className="flex justify-center gap-2">
                        <Link
                          to={`/employee/${row.id}`}
                          className={`flex justify-center items-center mx-auto px-2 py-1 rounded bg-[#de2b26]/10 cursor-pointer`}
                        >
                          <FiEdit className={`text-xs text-[#142b70]`} />
                        </Link>
                      </div>
                    ) : hasPermission("view_employees") ? (
                      <div className="flex justify-center gap-2">
                        <Link
                          to={`/employee/${row.id}`}
                          className={`flex justify-center items-center mx-auto px-2 py-1 rounded bg-[#de2b26]/10 cursor-pointer`}
                        >
                          <FiEdit className={`text-xs text-[#142b70]`} />
                        </Link>
                      </div>
                    ) : (
                      <span className={`text-xs text-[#142b70]`}>
                        Not Allowed
                      </span>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center py-4">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <Popup
          isOpen={disableOpen}
          onClose={() => setDisableOpen(false)}
          title="Disable Employee"
        >
          <div className="flex flex-col gap-6 mt-[30px] mb-[30px]">
            <div className="flex flex-col gap-2">
              <p className="text-sm text-[#142b70]/80 text-left">
                Are you sure and want to {selectedUserStatus.toLowerCase()}{" "}
                <b>{selectedEmployee?.employee_name}</b>?
              </p>
            </div>
          </div>

          <div className="flex justify-end gap-4">
            <button
              onClick={() => setDisableOpen(false)}
              className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
            >
              Cancel
            </button>
            <button
              onClick={() =>
                handleDisableEnable(selectedUserStatus, selectedEmployee?.id)
              }
              className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
            >
              {selectedUserStatus}
            </button>
          </div>
        </Popup>
      </div>

      {/* Pagination */}
      <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-4">
        <div className="relative w-[190px] h-[30px] flex items-center justify-between">
          {/* Page Selector */}
          <div className="flex items-center gap-2">
            <div className="flex items-center h-[26px] px-[10px] rounded-lg bg-[#f9f9f9] cursor-pointer relative">
              <select
                value={currentPage}
                onChange={(e) => handlePageChange(Number(e.target.value))}
                className="bg-transparent text-xs text-[#142b70]/80 focus:outline-none cursor-pointer appearance-none pr-5"
              >
                {Array.from({ length: totalPages }, (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>
              {/* Down Arrow */}
              <ArrowDownIcon
                iconClass="absolute right-2 pointer-events-none"
                color="#142b70"
              />
            </div>
            <p className="text-sm text-[#142b70]/80">of {totalPages} pages</p>
          </div>

          {/* Prev / Next Arrows */}
          <div className="flex items-center gap-3">
            {/* Prev */}
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="disabled:opacity-40"
            >
              <PrevIcon color="#142b70" />
            </button>

            {/* Next */}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="disabled:opacity-40"
            >
              <NextIcon color="#142b70" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeTable;
